import linegraph from '../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import { domainName } from "../../../../utility/index"
import moment from 'moment';

export default {
    props: {
        queryCarMaintain: {
          type: Function,
          default: null
        }
      },
    data() {
        return {
            orgId: '',
            carIdNumber: '',
            number: '',
            formInline: {
                projectId: [],
            },
            options: [],
            changeValue: [],
            amountOption: {},
            amountLoading: false,
            height: '500',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                // {
                //     prop: "batteryNumber",
                //     label: this.$t('BatteryAnalysis.batteryNumber'),
                //     align: "center",
                // },
                {
                    prop: "carId",
                    label: this.$t('BatteryAnalysis.carId'),
                    align: "center",
                },
                // {
                //     prop: "terminalId",
                //     label: this.$t('BatteryAnalysis.terminalId'),
                //     align: "center",
                //     width: '140'
                // },
                {
                    prop: "orgName",
                    label: this.$t('BatteryAnalysis.orgName'),
                    align: "center",

                },
                {
                    prop: "project",
                    label: this.$t('VehicleManagement.mainMaintenanceItems'),
                    align: "center",

                },
                {
                    prop: "projectName",
                    label: '保养明细',
                    align: "center",

                },
                {
                    prop: "projectOptionStr",
                    label: "保养状态",
                    align: "center",

                },
                {
                    prop: "operateTime",
                    label: "保养时间",
                    align: "center",
                },
                {
                    prop: "operateUser",
                    label: "保养人",
                    align: "center",

                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            // isShow: true,
            currentPage: 1,
            pageSize: 10,
            total: 1,
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    created() {
        this.getDate()
        this.getTreeChange()
    },
    methods: {
        initQuery(type) {
            this.type = type
            this.pageSize = 10
            this.currentPage = 1
            this.getMonthOrderList()
            // if (type == 'one') {
            //     this.isShow = false
            //     this.columns = this.columnsOne
            //     this.getOneMonthOrderList()
            // } else {
            //     this.isShow = true
            //     this.columns = this.columnsAll
            //     this.getMonthOrderList()
            // }
        },
        getDate() {
            const endTime = moment().subtract(1, "day").format("YYYY-MM-DD");
            const startTime = moment().subtract(6, "month").format("YYYY-MM-DD");
            this.changeValue = [startTime, endTime];
            this.queryCarMaintain(this.changeValue)
            this.$emit('changeData', this.changeValue)
        },
        changeTime() {
            this.getcarCompare()
            this.getMonthOrderList()
            this.queryCarMaintain(this.changeValue)
            // if (this.type == 'one') {
            //     this.isShow = false
            //     this.columns = this.columnsOne
            //     this.getOneMonthOrderList()
            // } else {
            //     this.isShow = true
            //     this.columns = this.columnsAll
            //     this.getMonthOrderList()
            // }
        },
        getcarCompare() {
            this.amountLoading = true
            let obj = {
                Data: [],
                // ChargingTime: [],
                // DischargeTime: [],
                ChargingCount: [],
                // DischargeCount: [],
            }
            let param = {
                orgId: Number(this.orgId),
                carId: this.carIdNumber,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            }
            this.$store.dispatch("MaintenanceAnalysis/GET_SELECTMAINTAINNUMBER", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        res.data.data.map((item, index) => {
                            obj.Data.push(item.projectName)
                            obj.ChargingCount.push(item.maintainCount == null ? 0 : item.maintainCount)
                            // obj.DischargeCount.push(item.dischargeCount == null ? 0 : item.dischargeCount)
                            // obj.ChargingTime.push(item.chargeTime == null ? 0 : item.chargeTime)
                            // obj.DischargeTime.push(item.dischargeTime == null ? 0 : item.dischargeTime)
                        })
                        this.carCompare(obj)
                    }
                }
                this.amountLoading = false
            }).catch(err => {
                this.amountLoading = false
            })
        },
        carCompare(amountData) {
            let option = {
                tooltip: {
                    trigger: 'axis',
                },
                // legend: {
                //     left: 'center',
                //     data: [this.$t('BatteryAnalysis.chargeTime'), this.$t('BatteryAnalysis.dischargeTime'), this.$t('BatteryAnalysis.chargeCount'), this.$t('BatteryAnalysis.dischargeCount')],
                //     top: '10',
                //     itemWidth: 15, 
                //     itemHeight: 15, 
                //     textStyle: {
                //         color: '#fff'
                //     }
                // },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',

                        }
                    },
                    splitLine: { show: false },
                    data: amountData.Data
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '5%',
                    containLabel: true,
                },
                yAxis: [
                    {
                        type: 'value',
                        name: this.$t('BatteryAnalysis.count'),
                        nameTextStyle: {
                            color: "white",
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            color: '#fff'
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ['rgba(173,177,195,.1)'],
                                type: 'dashed'
                            }
                        },
                        // splitLine: {
                        //     show: true,
                        //     lineStyle: {
                        //         color: ['rgba(173,177,195,.1)'],
                        //         type: 'dashed'
                        //     }
                        // },
                        // axisTick: {
                        //     show: false,
                        // },
                        // axisLabel: {
                        //     color: '#fff'
                        // }
                    },
                    // {
                    //     type: 'value',
                    //     name: this.$t('BatteryAnalysis.duration'),
                    //     nameTextStyle: {
                    //         color: "white",
                    //     },
                    //     axisTick: {
                    //         show: false
                    //     },
                    //     axisLabel: {
                    //         color: '#fff'
                    //     },
                    //     splitLine: {
                    //         show: true,
                    //         lineStyle: {
                    //             color: ['rgba(173,177,195,.1)'],
                    //             type: 'dashed'
                    //         }
                    //     },
                    // }
                ],
                series: [
                    // {
                    //     name: this.$t('BatteryAnalysis.chargeCount'),
                    //     type: 'line',
                    //     smooth: true,
                    //     data: amountData.ChargingCount,
                    //     color: '#f33a3a',
                    // },
                    // {
                    //     name: this.$t('BatteryAnalysis.dischargeCount'),
                    //     type: 'line',
                    //     smooth: true,
                    //     data: amountData.DischargeCount,
                    //     color: '#fec055'
                    // },
                    {
                        name: this.$t('VehicleManagement.numberOfMaintenanceItems'),
                        // yAxisIndex: 1,
                        data: amountData.ChargingCount,
                        type: 'bar',
                        barCategoryGap: '40%',
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#16e1ff' },
                                        { offset: 1, color: '#1ee2ff' },
                                    ]
                                )
                            },
                        }
                    },
                    // {
                    //     name: this.$t('BatteryAnalysis.dischargeTime'),
                    //     yAxisIndex: 1,
                    //     data: amountData.DischargeTime,
                    //     type: 'bar',
                    //     barCategoryGap: '40%',
                    //     itemStyle: {
                    //         normal: {
                    //             color: new echarts.graphic.LinearGradient(
                    //                 0, 0, 0, 1,
                    //                 [
                    //                     { offset: 0, color: '#007cfc' },
                    //                     { offset: 1, color: '#409eff' },
                    //                 ]
                    //             )
                    //         },
                    //     }
                    // },
                ]
            }
            this.amountOption = option
        },

        getTreeChange() {
            this.$store.dispatch('MaintenanceProgram/GET_SELECTTREEFORMPROJECT', {}).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.options = res.data.data
                    }
                }
            }).catch(err => { })
        },
        handleChange(value) {},
        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                carId: this.carIdNumber,
                projectId: this.formInline.projectId[1],
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            };
            this.$store.dispatch('MaintenanceAnalysis/GET_SELECTMAINTAIN', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getMonthOrderList()
        },
        onClear() {
            this.formInline = {
                projectId: [],
            },
            this.getMonthOrderList()
        },
        // getOneMonthOrderList() {
        //     let param = {
        //         orgId: this.orgId,
        //         pageNum: this.currentPage,
        //         pageSize: this.pageSize,
        //         batteryNumber: this.batteryNumber,
        //         warningType: this.formInline.warningType,
        //         startTime: this.changeValue[0],
        //         endTime: this.changeValue[1],
        //     };
        //     this.$store.dispatch('BatteryAnalysis/GET_QUERYBATTERYSINGLEPAGE', param).then(res => {
        //         if (res) {
        //             if (res.data.code == 200) {
        //                 this.list = res.data.data.list
        //                 this.$refs.page.CommandTotal = res.data.data.total
        //             }
        //         }
        //     }).catch(err => { })
        // },
        downCar() {
            if (domainName) {
                let projectId = ''
                if(this.formInline.projectId.length > 0) {
                    projectId = this.formInline.projectId[1]
                }else {
                    projectId = ''
                }
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportMaintain?orgId=${this.orgId}&carId=${this.carIdNumber}&projectId=${projectId}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportMaintain?orgId=${this.orgId}&carId=${this.carIdNumber}&projectId=${projectId}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                    location.href = url
                }
            }
        },
        // down() {
        //     if (domainName) {
        //         if (domainName.split(':')[0] !== 'localhost') {
        //             let url = `https://${domainName}/v1/getExportExcel/battery/uploadBatterySinglePage?orgId=${this.orgId}&batteryNumber=${this.bindBattery}&warningType=${this.formInline.warningType}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
        //             location.href = url
        //         } else {
        //             let host = 'localhost:8080'
        //             let url = `https://${host}/v1/getExportExcel/battery/uploadBatterySinglePage?orgId=${this.orgId}&batteryNumber=${this.bindBattery}&warningType=${this.formInline.warningType}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
        //             location.href = url
        //         }
        //     }
        // },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getMonthOrderList()
            // if (this.type == 'one') {
            //     this.columns = this.columnsOne
            //     this.getOneMonthOrderList()
            // } else {
            //     this.columns = this.columnsAll
            //     this.getMonthOrderList()
            // }
        },
    }
}
